module.exports = __webpack_public_path__ + "img/Cetus.f2af9a29.png";